const USER_TOKEN = "";
const USER_ID = "_loginUserId";

export function setUser(user) {
  window.localStorage.setItem(USER_TOKEN, JSON.stringify(user));
}

export function getUser() {
  return JSON.parse(window.localStorage.getItem(USER_TOKEN));
}

export function delUser() {
  localStorage.removeItem(USER_TOKEN);
}

export function setUserId(userId) {
  window.localStorage.setItem(USER_ID, JSON.stringify(userId));
}

export function getUserId() {
  return JSON.parse(window.localStorage.getItem(USER_ID));
}

export function delUserId() {
  localStorage.removeItem(USER_ID);
}
